import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

function Breadcrumbs({ lastLabel }) {
  const location = useLocation();
  
  // Parse pathname into breadcrumb items
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Map route names to readable labels
  const routeLabels = {
    'dashboard': 'Dashboard',
    'projects': 'Projects',
    'datasets': 'Datasets',
    'upload': 'Upload Data',
    'map': 'Map View',
    'settings': 'Settings',
    'signin': 'Sign In',
    'signup': 'Sign Up',
    'forgot-password': 'Forgot Password',
    'reset-password': 'Reset Password',
  };
  
  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-4" aria-label="Breadcrumb">
      <Link 
        to="/" 
        className="flex items-center hover:text-foreground transition"
        data-testid="breadcrumb-home"
      >
        <Home className="w-4 h-4" />
      </Link>
      
      {pathnames.length > 0 && <ChevronRight className="w-4 h-4" />}
      
      {pathnames.map((pathname, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = (isLast && lastLabel) || routeLabels[pathname] || pathname;
        
        return (
          <React.Fragment key={routeTo}>
            {isLast ? (
              <span className="text-foreground font-medium" data-testid={`breadcrumb-current`}>
                {label}
              </span>
            ) : (
              <>
                <Link 
                  to={routeTo} 
                  className="hover:text-foreground transition"
                  data-testid={`breadcrumb-${pathname}`}
                >
                  {label}
                </Link>
                <ChevronRight className="w-4 h-4" />
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumbs;
